import React from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { JsonTree } from '../../../../components/jsonEditorV2/jsontree/JsonTree';
import { HTTP_METHOD_OPTIONS, TYPES_API, SUBTYPES_API, URLS_OPTIONS } from '../../constants/interface.constants';

export const TriggerForm = ({ values = null, errorInputs = {}, onFieldsChange, t }) => {
    const [ formValues, setFormValues ] = React.useState(
        {
            type: 'api_integration',
            subtype: 'rest',
            method: 'GET',
            url: '',
            bodyData: {}
        }
    );

    React.useEffect(() => {
        if (values)
            setFormValues(values);
    }, [ values ])

    const handleChange = (event) => {
        const { name, value } = event.target;
        let js = { ...formValues, [ name ]: value };
        setFormValues(js);
        onFieldsChange([ js ]);
    };

    const handleChangeBD = (key, obj) => setFormValues({ ...formValues, [ key ]: obj });

    return (
        <Box>
            <Grid container spacing={ 2 } alignItems="center">
                <Grid size={ { xs: 10, sm: 10 } }>
                    <Typography variant='h6' component='h6'>
                        Trigger
                    </Typography>
                </Grid>

                <Grid size={ { xs: 12, sm: 6 } }>
                    <FormControl fullWidth required size="small"
                        error={ Boolean(errorInputs.type?.isError) }
                    >
                        <InputLabel id="type">Type</InputLabel>
                        <Select labelId="type" name="type" label="Type"
                            value={formValues.type}
                            onChange={handleChange}
                        >
                            {TYPES_API.map(t => <MenuItem key={t.value} value={t.value} sx={{fontWeight: 600}}>{t.label}</MenuItem>)}
                        </Select>
                        {errorInputs.type?.isError && <FormHelperText>{errorInputs.type.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={ { xs: 12, sm: 6 } }>
                    <FormControl fullWidth required size="small"
                        error={ Boolean(errorInputs.subtype?.isError) }
                    >
                        <InputLabel id="subtype">Subtype</InputLabel>
                        <Select labelId="subtype" name="subtype" label="Subtype"
                            value={formValues.subtype}
                            onChange={handleChange}
                        >
                            {SUBTYPES_API.map(s => <MenuItem key={s.value} value={s.value} sx={{fontWeight: 600}}>{s.label}</MenuItem>)}
                        </Select>
                        {errorInputs.subtype?.isError && <FormHelperText>{errorInputs.subtype.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={ { xs: 12, sm: 6 } }>
                    <FormControl fullWidth required size="small"
                        error={ Boolean(errorInputs.method?.isError) }
                    >
                        <InputLabel id="method">Method</InputLabel>
                        <Select labelId="method" name="method" label="Method"
                            value={formValues.method}
                            onChange={handleChange}
                        >
                            {HTTP_METHOD_OPTIONS.map(m => <MenuItem key={m.value} value={m.value} sx={{fontWeight: 600}}>{m.label}</MenuItem>)}
                        </Select>
                        {errorInputs.method?.isError && <FormHelperText>{errorInputs.method.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={ { xs: 12, sm: 6 } }>
                    <FormControl fullWidth required size="small"
                        error={ Boolean(errorInputs.url?.isError) }
                    >
                        <InputLabel id="url">Url</InputLabel>
                        <Select labelId="url" name="url" label="Url"
                            value={formValues.url}
                            onChange={handleChange}
                        >
                            {URLS_OPTIONS.map(u => <MenuItem key={u.value} value={u.value} sx={{fontWeight: 600}}>{u.label}</MenuItem>)}
                        </Select>
                        {errorInputs.url?.isError && <FormHelperText>{errorInputs.url.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={ { xs: 12, sm: 6 } }>
                    <JsonTree keyParent={ 'bodyData' } contentJson={ formValues.bodyData } handleChange={ handleChangeBD } />
                </Grid>
            </Grid>
        </Box>
    );
};

